const TIME_FORMATS = {
  SHORT: "HH:mm",
  LONG: "HH:mm:ss"
};
export {
  TIME_FORMATS
};
